module.exports = __webpack_public_path__ + "img/order_bag.753dc585.png";